module.exports = __webpack_public_path__ + "img/common/dragndrop.204339.png";